import React from "react"
import Section1 from "./Sections/section1.tsx";
import Section2 from "./Sections/section2.tsx";
import Section4 from "./Sections/section4.tsx";
import Section5 from "./Sections/section5.tsx";
import Section6 from "./Sections/section6.tsx";
import Section3 from "./Sections/section3.tsx";

const VR_Main: React.FC = () => {

    // dividing in Sections

    /**
     * section 1 
     * top logo
     * main video
     * center text
     *  
     * */

    /**
     * section 2
     * text
     * card layout
     * single line text
     * carousel
     */

    /**
     * Section 3
     * h2 scientific text
     * flip card
     * 
     */

    /**
     * Section 4
     * h2 monitor text
     * p tag
     * h2 coming soon text
     * brand_logos images
     * hr line
     */

    /**
     * Section 5
     * p tag
     * connect with us button
     * ContactUs Modal
     */

    /**
     * Section 6
     * footer
     */

    return (
        <>
            <Section1 />
            <Section2 />
            <Section3 />
            <Section4 />
            <Section5 />
            <Section6 />
        </>
    );

}


export default VR_Main